import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {
    accountSearchResultCrmIntegrationDataSelector,
    accountSearchResultCrmIntegrationResultSelector,
} from '../../slices/account-search-result-crm-integration.slice';

type Props = {
    accountId: number,
};

export const MsDynamicsIntegrationCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultCrmIntegrationDataSelector);
    const result = useSelector(accountSearchResultCrmIntegrationResultSelector);

    const msDynamicsEnabled = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].msdEnabled ? 'Yes' : 'No';
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !msDynamicsEnabled) {
        return null;
    }

    return (
        <span>{msDynamicsEnabled}</span>
    );
};
